var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFingerprint = function SvgFingerprint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M8 48C8 26 26 8 48 8a40 40 0 0 1 32 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M20 78c2-6 4-18 4-30 0-2.8.48-5.48 1.36-8M69.16 84.08c.48-2.4 1.72-9.2 2-12.08M48 40a8 8 0 0 0-8 8c0 4.08-.4 10.04-1.04 16M34.6 88c.84-2.64 1.8-5.28 2.28-8M56 52.48C56 62 56 78 52 88M8 64h.04M87.2 64c.8-8 .524-21.416 0-24M36 27.2A24 24 0 0 1 72 48c0 1.88 0 4.68-.08 8"
  })));
};
export default SvgFingerprint;